"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootStyles = exports.ToggleButtonGroupBase = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _context = require("../context");

var rootStyles = {
  '--st-group-button-width': '1px',
  '--st-group-button-focus-width': '2px'
};
exports.rootStyles = rootStyles;
var ToggleButtonGroupBase = (0, _context.styledWithTheme)('fieldset')(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {
    display: 'flex',
    flexDirection: 'row',
    border: 'none'
  }, (0, _defineProperty2.default)(_ref2, "& > button:not(:first-of-type)", {
    borderLeftWidth: 'var(--st-group-button-width)'
  }), (0, _defineProperty2.default)(_ref2, "& > button:not(:last-of-type)", {
    borderRightWidth: 'var(--st-group-button-width)'
  }), (0, _defineProperty2.default)(_ref2, "& > button:focus", {
    zIndex: 1,
    boxShadow: "0 0 0 1px ".concat(theme.selectors.color('neutral0')),
    '&:not(:first-of-type)': {
      borderLeftWidth: 'var(--st-group-button-focus-width)'
    },
    '&:not(:last-of-type)': {
      borderRightWidth: 'var(--st-group-button-focus-width)'
    }
  }), _ref2;
});
exports.ToggleButtonGroupBase = ToggleButtonGroupBase;